var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fill":"#FFFFFF","points":"10,4 0,4 0,6 10,6 "}));
}

Minus.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"10px","height":"10px","viewBox":"0 0 10 10","enableBackground":"new 0 0 10 10","xmlSpace":"preserve"};

module.exports = Minus;

Minus.default = Minus;



// WEBPACK FOOTER //
// ./src/icons/minus.svg